module.exports = __webpack_public_path__ + "static/orc_nurtured_one_of_yurtrus-8729f5f9745dbc97140b999b0b563885.jpeg";